import { useEffect } from 'react';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';
import Seo from '../components/Seo';
import { Check } from '../components/Icons';
import { Brand } from '../components/Brand';
import { jsonLdGraph, organizationSchema, websiteSchema } from '../lib/seo';
import '../styles/waitlist.css';

const LAUNCHLIST_SRC = 'https://getlaunchlist.com/js/widget.js';

export default function WaitlistPage() {
  // The GetLaunchList widget script scans the DOM for ".launchlist-widget"
  // elements and turns them into the sign-up form. In a single-page app the
  // script has to run *after* this route has mounted, so we (re)inject it on
  // mount and remove it on unmount.
  useEffect(() => {
    document.querySelectorAll(`script[src="${LAUNCHLIST_SRC}"]`).forEach((s) => s.remove());

    const script = document.createElement('script');
    script.src = LAUNCHLIST_SRC;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <>
      {/*
        The meta description below deliberately keeps the word "checklist": it is invisible to
        readers and is still what people type into a search box. The visible copy on this page says
        "requirements", matching the product.
      */}
      <Seo
        title="Join the reeve waitlist for early access"
        description="Join the reeve waitlist for early access to the HR document checklist and UK employment-law copilot for small businesses. We'll invite you the moment it's ready."
        path="/waitlist"
        jsonLd={[jsonLdGraph([organizationSchema, websiteSchema])]}
      />
      <SiteNav variant="minimal" />
      <main>
        <section className="waitlist container">
          <div className="waitlist__inner">
            <span className="eyebrow">Early access</span>
            <h1 className="waitlist__title">
              Join the <Brand /> waitlist.
            </h1>
            <p className="waitlist__lead">
              <Brand /> isn’t open to everyone just yet. Leave your email and we’ll invite you the
              moment your HR requirements and UK-law copilot are ready.
            </p>

            <div className="waitlist__card">
              <h2 className="waitlist__card-title">Request an invite</h2>
              {/* GetLaunchList embedded widget */}
              <div className="launchlist-widget" data-key-id="nuZnh4" />
              <p className="waitlist__fine">
                We’ll only email you about early access. Unsubscribe any time.
              </p>
            </div>

            <div className="waitlist__badges">
              <span className="waitlist__badge">
                <Check /> Your tailored document requirements
              </span>
              <span className="waitlist__badge">
                <Check /> The UK-law AI advisor
              </span>
              <span className="waitlist__badge">
                <Check /> A qualified human when it’s serious
              </span>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
